import { Field } from 'models/Field';

const valueFields = (field: Field) => field.name !== 'bd_Show';
const fieldIsValid = (field: Field) => !!field.value;

export const fieldValidator = (fieldArray: Field[]) => {
  return fieldArray.filter(valueFields).every(fieldIsValid);
};
